const styles = {
  loader: { left: '50%', marginLeft: '-10px', position: 'absolute' },
};

export default styles;
